module.exports = __webpack_public_path__ + "img/082-united-nations.a2e14211.svg";